import {Injector} from "@angular/core"
import {IsUnique} from "@cm/utils/filter"
import {fetchThrowingErrors} from "@common/helpers/api/fetch"
import {BatchApiCall} from "@common/helpers/batch-api-call/batch-api-call"
import {ApiRequest} from "@common/models/api-request/api-request"
import {
    ConfiguratorResolvedTextureRevisionFragment,
    ConfiguratorResolveTextureRevisionsLegacyGQL,
} from "@app/material-editor/services/configurator-texture-revision-batch-api-call.generated"

type RequestPayload = {
    legacyId: number
}

type ResponsePayload = ConfiguratorResolvedTextureRevisionFragment

type BatchedRequestPayload = {
    requests: ApiRequest<RequestPayload, ResponsePayload>[]
}

export class ConfiguratorTextureRevisionLegacyBatchApiCall extends BatchApiCall<RequestPayload, ResponsePayload, BatchedRequestPayload> {
    constructor(private injector: Injector) {
        super(1)
    }

    protected dispatchResponses(batchedPayload: BatchedRequestPayload, responses: ResponsePayload[]) {
        const requestsById = new Map<number, ApiRequest<RequestPayload, ResponsePayload>[]>()
        batchedPayload.requests.forEach((request) => {
            if (!requestsById.has(request.payload.legacyId)) {
                requestsById.set(request.payload.legacyId, [])
            }
            requestsById.get(request.payload.legacyId)!.push(request)
        })
        responses.forEach((response) => {
            const requests = requestsById.get(response.legacyId)
            if (!requests) {
                throw new Error("No request not found")
            }
            requests.forEach((request) => request.resolve(response))
            requestsById.delete(response.legacyId)
        })
        requestsById.forEach((requests) => requests.forEach((request) => request.reject("No response received")))
    }

    protected batchRequests(requests: ApiRequest<RequestPayload, ResponsePayload>[]): BatchedRequestPayload[] {
        return [{requests}]
    }

    protected async callApi(payload: BatchedRequestPayload): Promise<(ResponsePayload | undefined | null)[]> {
        const legacyIds = payload.requests.map((request) => request.payload.legacyId).filter(IsUnique)
        const configuratorResolveTextureRevisionsLegacyGQL = this.injector.get(ConfiguratorResolveTextureRevisionsLegacyGQL)
        return fetchThrowingErrors(configuratorResolveTextureRevisionsLegacyGQL)({
            legacyIds,
        }).then((response) => response.configuratorTextureRevisions)
    }
}
